import { Callout } from "@src/appV2/redesign/system/ui-components";
import { useHistory, useLocation } from "react-router-dom";

import { SHIFT_DISCOVERY_IN_HOME_COMMS_BANNER_PATH } from "../../ShiftDiscovery/paths";
import { useIsInHomeEnabled } from "../lib/useIsInHomeEnabled";

export function InHomeCommsBannerCallout() {
  const history = useHistory();
  const location = useLocation();
  const isInHomeEnabled = useIsInHomeEnabled();

  if (!isInHomeEnabled) {
    return null;
  }

  return (
    <Callout
      title="Get paid for Home Visits"
      iconType="info"
      sx={(theme) => ({
        backgroundColor: theme.palette.intent?.neutral.background,
        color: theme.palette.intent?.neutral.text,
      })}
      onClick={() => {
        history.push(`${location.pathname}/${SHIFT_DISCOVERY_IN_HOME_COMMS_BANNER_PATH}`);
      }}
    />
  );
}
